var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"progress-bar__track"},[_c('span',{staticClass:"progress-bar__fill",style:({ width: (_vm.clampedPercentage + "%"), backgroundColor: _vm.color })})])}
var staticRenderFns = []

export { render, staticRenderFns }